export default __webpack_public_path__ + "static/media/Boots of the Bloodhunter (nm).87a0ec0b.jpg";